import { Component } from '@angular/core';

import { take, takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SingleDetailComponent } from 'app/shared/components/single-detail/single-detail.component';
import { ISiteLocationDetailsModel } from 'app/shared/models/site-location.models';
import { SiteLocationService } from 'app/shared/services/site-location.service';

import { ScannedDetailsComponentBase } from '../ScannedDetailsComponentBase';

@Component({
  selector: 'app-scanned-location-details',
  templateUrl: './scanned-location-details.component.html',
  styleUrls: ['./scanned-location-details.component.css'],
  standalone: true,
  imports: [SingleDetailComponent],
})
export class ScannedLocationDetailsComponent extends ScannedDetailsComponentBase {
  public siteLocationDetails: ISiteLocationDetailsModel;

  constructor(private siteLocationService: SiteLocationService) {
    super();
  }

  handleCodeScanned(): void {
    this.siteLocationService
      .getSiteLocationDetailsByLabelCodeV1(this.labelCode.identifier)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (siteLocationDetailsModel: ISiteLocationDetailsModel) => {
          this.siteLocationDetails = siteLocationDetailsModel;
          this.navigationInstructions.emit([
            `/sites/${siteLocationDetailsModel.siteId}/locations`,
            siteLocationDetailsModel.id,
          ]);
        },
        error: (_error) => this.handleScanFail(),
      });
  }
}
